// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/feature-export/tauri-delivery.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/plugins/src/export/tauri-delivery.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo bodega-sync-app
//     node fleet/fleet.ts check --repo bodega-sync-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * Desktop delivery for exports.
 *
 * A Tauri WebView does not reliably honour `<a download>`, so the browser path
 * can silently do nothing there. This writes the file through the native save
 * dialog instead — the same pattern `lib/api.ts` already uses for attachments —
 * and degrades to the browser delivery if the plugins or the scope are not
 * usable, so the user is never blocked on a missing native capability.
 */
import { browserDelivery, type ExportDelivery } from "@fleet/export";

async function saveThroughDialog(filename: string, content: string): Promise<boolean> {
  try {
    const [{ save }, { writeTextFile }] = await Promise.all([
      import("@tauri-apps/plugin-dialog"),
      import("@tauri-apps/plugin-fs"),
    ]);
    const path = await save({ defaultPath: filename });
    if (!path) {
      // The user dismissed the dialog: that is a completed interaction, not a
      // failure. Falling back here would download the file behind their back.
      return true;
    }
    await writeTextFile(path, content);
    return true;
  } catch (error) {
    console.warn("[Export] native save unavailable, falling back to blob:", error);
    return false;
  }
}

export const tauriDelivery: ExportDelivery = {
  kind: "file-system",
  async saveText(filename, content, mimeType) {
    if (!(await saveThroughDialog(filename, content))) {
      await browserDelivery.saveText(filename, content, mimeType);
    }
  },
  async deliverPrintable(filename, html) {
    if (!(await saveThroughDialog(filename, html))) {
      await browserDelivery.deliverPrintable(filename, html);
    }
  },
};
